// extracted by mini-css-extract-plugin
module.exports = {"item":"ExtraItem-module--item--2uJWV","icon":"ExtraItem-module--icon--15GI4"};